import { render, staticRenderFns } from "./IpEdit.vue?vue&type=template&id=d95c2e8c&scoped=true"
import script from "./IpEdit.vue?vue&type=script&lang=js"
export * from "./IpEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95c2e8c",
  null
  
)

export default component.exports